import axios from 'axios'
import { DecryptData } from '../../utils/encryptDecrypt'
import { url, endPoint } from '../urls'

export const getToken = async (params) => {
  let _url = url.cubeTokenUrl + endPoint.token.getToken
  params = params || {}
  return axios.get(_url, { params })
}


